import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { _t, isEn } from "../../app/i18n/i18n";
import { usePublicFaq } from "../../lib/hooks/usePublicFaq";
import { LoadingSpinner } from "../../lib/Spinner";
import { DataErrorMsg } from "../../pages/AnalystDirectory/AnalystDirectory";
import ErrorBoundary from "../../lib/ErrorBoundary";
import { PublicFaqHeader } from "../../components/PublicFaq/PublicFaqHeader";
import { PublicFaqBody } from "../../components/PublicFaq/PublicFaqBody";
import { history } from "../../redux/configureStore";
import "pages/Faq/faq.css";

export const PublicFaqPage = () => {
  const [publicFaqItems, isLoading, isError] = usePublicFaq();

  const categories = publicFaqItems.length ?
    [...new Set(publicFaqItems.map(item =>
      isEn() ? item.category_en : item.category_ja
    ))] : [];

  return (
    <ErrorBoundary>
      <Container>
        <Row className="justify-content-center">
          <Col lg={12} md={12}>
            <div className="mt-5">
              <PublicFaqHeader />

              {isLoading && <LoadingSpinner />}
              {isError && <DataErrorMsg />}
              {publicFaqItems.length > 0 && (
                <PublicFaqBody
                  faq={publicFaqItems}
                  categories={categories}
                />
              )}

              <div className="d-flex justify-content-end mt-4 mb-3">
                <Button variant="secondary" onClick={() => history.push("/public/login")}>
                  {_t("Back")}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
};